// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ReportIsScrollable = t.Boolean;

export const getDefaultState = () => false;

export default ReportIsScrollable;



// WEBPACK FOOTER //
// ./src/reports/shared/state/report-is-scrollable.js